var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',[_c('render-content',{attrs:{"id":"contractmanagerwelcome"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }